export default __webpack_public_path__ + "static/dragon-56a1ecfd34e0a38b71f121478e06251c.png";